import { motion } from "framer-motion";
import { CheckCircle2, TrendingUp, CalendarClock } from "lucide-react";

const BADGES = {
  fact: { label: "Current fact", cls: "bg-emerald-950/60 text-emerald-300 border-emerald-500/30", Icon: CheckCircle2 },
  projected: { label: "Projected", cls: "bg-amber-950/60 text-[#E3BC6E] border-amber-500/30", Icon: TrendingUp },
  dated: { label: "Dated update", cls: "bg-sky-950/60 text-sky-200 border-sky-300/30", Icon: CalendarClock },
};

export const ClaimBadge = ({ type, testId }) => {
  const b = BADGES[type] ?? BADGES.fact;
  return (
    <span data-testid={testId || `claim-badge-${type}`} className={`inline-flex items-center gap-1.5 border px-2 py-0.5 font-mono text-[11px] uppercase tracking-[0.14em] ${b.cls}`}>
      <b.Icon className="h-3 w-3" strokeWidth={2.2} />
      {b.label}
    </span>
  );
};

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0.35, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}>
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.22em] text-[#D4A24C] ${className}`}>{children}</p>
);

export const SectionHead = ({ eyebrow, title, body, id }) => (
  <Reveal className="mb-12 max-w-3xl md:mb-16">
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 id={id} className="font-display mt-4 text-4xl font-bold uppercase leading-[0.95] sm:text-5xl lg:text-6xl">{title}</h2>
    {body && <p className="mt-5 text-base text-slate-300 md:text-lg">{body}</p>}
  </Reveal>
);

export const MaskedLines = ({ lines, className = "", delay = 0.15 }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={i} className="-mt-[0.15em] block overflow-hidden pb-[0.06em] pt-[0.15em]">
        <motion.span className="block" initial={{ y: "105%" }} animate={{ y: "0%" }} transition={{ duration: 1.05, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}>
          {l}
        </motion.span>
      </span>
    ))}
  </span>
);

